import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { restrictToLawyer, search } from '../../../../state/actions';
import { StateType } from '../../../../../state/reducers';

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onRestrictToLawyer(data: {
    lawyerId: string;
    lawyerName: string;
    juridiction?: string;
    ville?: string;
  }) {
    dispatch(restrictToLawyer(data));
    dispatch(search({ reason: 'restrict-from-snippet' }));
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
